import { StopPointHelper } from '../../../../../../../../../helpers/stop-point.helper';
import { useTexts } from '../../../../../../../../../hooks/texts.hook';
import { StopPointType } from '../../../../../../../../../models/stop-point-type.enum';
import { IStopPoint } from '../../../../../../../../../models/stop-point.model';

function RealTimeAndPlannedPlatforms({
  stopPoint,
  realtimeStopPoint,
  className = '',
}: {
  stopPoint: IStopPoint | undefined;
  realtimeStopPoint: IStopPoint | undefined;
  className?: string | undefined;
}) {
  const { t } = useTexts();

  if (!stopPoint?.platform) {
    return null;
  }

  const platform = stopPoint.platform && stopPoint.platform !== '-' ? `${StopPointHelper.stopPointTypeTranslation(stopPoint)} ${stopPoint.platform}` : undefined;
  const realTimePlatform =
    realtimeStopPoint?.platform && realtimeStopPoint?.platform !== '-' ? `${StopPointHelper.stopPointTypeTranslation(realtimeStopPoint)} ${realtimeStopPoint.platform}` : undefined;

  return (
    <span className="text-nowrap">
      {realTimePlatform && (
        <span className={`${className}`}>
          <span className="visually-hidden">{realtimeStopPoint?.stopPointType === StopPointType.trainStop ? t('Nytt spår', 'New track') : t('Nytt läge', 'New platform')}:</span>
          {realTimePlatform}
        </span>
      )}
      {platform && (
        <span className={`${className} ${realTimePlatform ? 'text-decoration-line-through ms-1' : ''}`}>
          {realTimePlatform && (
            <span className="visually-hidden">{realtimeStopPoint?.stopPointType === StopPointType.trainStop ? t('Ordinarie spår', 'Regular track') : t('Ordinarie läge', 'Regular platform')}:</span>
          )}
          {platform}
        </span>
      )}
    </span>
  );
}

export default RealTimeAndPlannedPlatforms;
